import React from "react";
import { inject, observer } from "mobx-react";
import { getDataWithQueryString } from "../../api/componentAPIs";
import Events from "../../utilities/EventEmitter";

@inject("CommonStore")
@observer
class ParameterListener extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.getParametersData(this.props.scenarioId);
    Events.on("updateParametersData", this.getParametersData);
  }

  componentDidUpdate(prevProps){
    if(prevProps.scenarioId !== this.props.scenarioId){
        this.getParametersData(this.props.scenarioId)
    }
  }

  componentWillUnmount() {
    Events.off("updateParametersData", this.getParametersData);
  }

  getParametersData = (scenarioID) => {
    if(!scenarioID){
      this.props.CommonStore.updateParametersData([]);
      return;
    }
    getDataWithQueryString("GetParameters", `scenarioId=${scenarioID}`).then(
      (response) => {
        if (response && response.status === 200) {
          this.props.CommonStore.updateParametersData(response.data);
        } else {
          this.props.CommonStore.updateParametersData([]);
        }
      }
    );
  };

  render() {
    return null;
  }
}

export default ParameterListener